import React from "react";
import SelectedSearchFilter from "search-filter/components/search-filter-bar/SelectedSearchFilter";
import useSearchFiltersFormState from "search-filter/hooks/useSearchFiltersFormState";
const SelectedFiltersOverview = () => {
  const selectedFilters = useSearchFiltersFormState();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, selectedFilters.toArray().map((filter) => /* @__PURE__ */ React.createElement(SelectedSearchFilter, { filter, key: filter.frontendId })));
};
export default SelectedFiltersOverview;
